import axios from "axios";

// the covid19 api url
const url = "https://covid19.mathdro.id/api";

// 1 fetchData function is to be used in Cards
export const fetchData = async (country) => {
  let changeableUrl = url;

  // If any country is selected, then the url will be changed just for that selected country.
  if (country) {
    changeableUrl = `${url}/countries/${country}`;
  }

  try {
    const response = await axios.get(changeableUrl);
    // console.log(response)

    const modifiedData = {
      confirmed: response.data.confirmed,
      recovered: response.data.recovered,
      deaths: response.data.deaths,
      lastUpdate: response.data.lastUpdate,
    };

    // return response;
    return modifiedData;
  } catch (error) {
    console.log(error);
  }
};

// 2 fetchDailyData function is to be used in Chart
export const fetchDailyData = async () => {
  try {
    const response = await axios.get(`${url}/daily`);
    // console.log(response.data);

    const modifiedData = response.data.map((dailyData) => ({
      confirmed: dailyData.confirmed.total,
      deaths: dailyData.deaths.total,
      date: dailyData.reportDate,
      // incidentRate: dailyData.incidentRate,
    }));

    console.log(modifiedData);
    return modifiedData;
  } catch (error) {}
};

// 3 countries function is to be used in CountryPicker
export const fetchCountries = async () => {
  try {
    const response = await axios.get(`${url}/countries`);
    // console.log(response.data);

    return response.data.countries.map((country) => country.name);
  } catch (error) {}
};
